export const Images = {
  ACDOCTORLOGO: require('./images/Logo.png'),
  ACICONSPLIT: require('./images/Split.png'),
  ACICONWINDOW: require('./images/Window.png'),
  ACICONCASSETTE: require('./images/Cassette.png'),
  ACICONVRV_VRF: require('./images/Vrv_Vrf.png'),
  ACICONTOWER: require('./images/Tower.png'),
  ACICONDUCTED: require('./images/Ducted.png'),
  GROUPICON: require('./images/Group.png'),
  TECHNICIANICON: require('./images/Technician.png'),
  ENQUIRIESICON: require('./images/Enquiries.png'),
  BOOKINGICON: require('./images/Bookings.png'),
  REVENUEICON: require('./images/Revenue.png'),
};
